import { IPublicClientApplication } from "@azure/msal-browser";
import { getToken } from "Components/Functions";
import { api } from "./apiConfig"

export const BookingAPI = {
    getSingle: async function (instance: IPublicClientApplication, bookingId: number) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: `Booking/GetBooking?booking_id=${bookingId}`,
            method: "GET",
            headers: { Authorization: header }
        })
        return response.data
    },
    getAll: async function (instance: IPublicClientApplication) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: "Booking/GetBookings",
            method: "GET",
            headers: { Authorization: header }
        })
        return response.data
    },
    add: async function (instance: IPublicClientApplication, startDate: string, endDate: string, vehicleId:number) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: `Booking/AddInitialBooking?start_date=${startDate}&end_date=${endDate}&vehicle_id=${vehicleId}`,
            method: "POST",
            headers: { Authorization: header }
        })
        return response.data
    },
    cancel: async function (instance: IPublicClientApplication, bookingId:number) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: `Booking/CancelBooking?booking_id=${bookingId}`,
            method: "POST",
            headers: { Authorization: header }
        })
        return response.data
    }
}